import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  useDisclosure,
  Select,
} from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import { jwtAxios } from "../services/axios";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import { useProjectAndFolder } from "../hooks/useProjectAndFolder";
import { mutate } from "swr";

function MoveProjectFolderDialog(props: { projectId: string }) {
  const { projectId } = props;
  const {folders} = useProjectAndFolder()

  const projectNames = folders ? Object.keys(folders) : [];

  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef<any>();

  const handleMove = useCallback(async () => {
    setIsLoading(true);
    const resp = await jwtAxios.post(`/projects/${projectId}/name`, { name: name + "/" + v4() });
    toast(`Saved`, { type: "success" });
    mutate("/projects");
    setIsLoading(false);
    onClose();
  }, [name, onClose, projectId]);

  return (
    <>
      <Text onClick={onOpen}>Move Project to Folder</Text>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Move Project to Folder
            </AlertDialogHeader>

            <AlertDialogBody>
              <Select placeholder="Select new folder" onChange={(e) => setName(e.target.value)}>
                {projectNames.map((row) => (
                  <option value={row}>{row}</option>
                ))}
              </Select>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button isDisabled={!name} isLoading={isLoading} colorScheme="blue" onClick={handleMove} ml={3}>
                Move Image
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export { MoveProjectFolderDialog };
